/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./updateLivestream.defs.js";
export { main as default } from "./updateLivestream.defs.js";
